import { GET_USER_ACCOUNT } from '../../helpers/graphqlQueries';
import emailjs from "emailjs-com";

export async function getUser(graphQLClient,email="",username="") {
  let userAccount = {};
  let userDataHasura = {};
  await graphQLClient
    .query({
      query: GET_USER_ACCOUNT,
      variables: { email, username }
    })
    .then(r => (userAccount = r?.data?.user_account[0]))
    .catch(e => console.log('GET_USER_ACCOUNT', e));
  userDataHasura=userAccount?.user_data;
  return({ userAccount, userDataHasura });
}

export async function sendWelcomeEmail(data) {
  const template_params = {
    contactEmail: data.email,
    contactFirstName: data.username,
  };
  const service_id = "default_service";
  const template_id = "welcome_to_gaba_";
  const user_id = "user_yIq3IIfTQ8ruKbjBAqYaQ";
  await emailjs.send(service_id, template_id, template_params, user_id);
}